/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
import { ApiUtil } from 'plugin/liferay-widgets-react-web';
import { Client } from 'external/lwr-client';

const administrationService = (m, o) => Client.invoke('/administration.fliwaspermissionapi/' + m, o);
const administrationServiceWithContext = (m, o, c) => Client.invokeWithContext('/administration.fliwaspermissionapi/' + m, o, c);
//const roleService = (m, o) => Client.invoke('/role/' + m, o);

const api = {

    getPermissionStatesByRoleId(dataItem) {
        return administrationService('get-fliwas-permission-states.1', {
            teamId: dataItem.id
        });
    },

    getPermissionState(query) {
        return administrationServiceWithContext('get-fliwas-permission-state.3', {
            nameSpace: query.nameSpace,
            fliwasPermission: query.fliwasPermission
        }, {});
    },

    listAllNamespaces(query) {
        return administrationServiceWithContext('list-all-name-spaces.1', {}, {});
    },

    getUserRoles(query) {
        return administrationService('get-user-roles.1', {
            userId: query.userId
        });
    },

    setFiliwasPermissions(item) {
        return administrationServiceWithContext('set-fliwas-permissions.3', {
            teamId: item.id,
            nameSpace: item.nameSpace
        }, { fliwasPermissions: item.fliwasPermissions });
    }

};

ApiUtil.namedApi('FliwasPermissionWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/FliwasPermissionWebApi.js